import React, { Component, RefObject } from "react";
// import { Form,  message, Button, Icon } from 'antd';
import { Upload, message, Icon } from "antd";
import { UploadFile, ShowUploadListInterface, RcCustomRequestOptions } from "antd/lib/upload/interface";
import UploadService from "../upload.service";
import "../style.css";
import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";
import GalleryTemplate from "./gallery";
export interface iProps {
  uploadSignURL?: string;
  maxFileNumber?: number;
  maxFileLength?: number;
  minFileLength?: number;
  fileType?: string;
  filePatten?: string;
  fileList?: any[];
  avatar?: any;
  action?: string;
  upload?: boolean;
  preview?: boolean;
  multiple?: boolean;
  directory?: boolean;
  disabled?: boolean;
  single?: boolean;
  showUploadList?: boolean | ShowUploadListInterface;
  onChange?: (files: any) => void;
  onRemove?: (files: any) => void;
  children?: React.ReactNode;
}
export default class FileUpload extends Component<iProps> {
  private ref: RefObject<HTMLSpanElement>;
  private uploadService: UploadService = new UploadService();
  state: any = {
    OSSData: {},
    fileList: [],
    previewVisible: false,
  };
  constructor(props: any) {
    super(props);
    this.ref = React.createRef();
  }
  initFileList = (fileList = []) => {
    return fileList.map((file) => ({
      ...file,
      thumbUrl:null,
      newUploadFlag:typeof file.newUploadFlag==='undefined'?false:file.newUploadFlag,
      url: file.fileUrl?.endsWith("style/thumbnail")
        ? file.fileUrl
        : `${file.fileUrl}?x-oss-process=style/thumbnail`,
    }));
  };

  componentDidMount() {
    const { fileList = [] } = this.props;
    this.setState({
      fileList: this.initFileList(fileList),
    });
  }
  componentWillReceiveProps(newProps) {
    const { fileList = [] } = newProps;
    this.setState({
      fileList: this.initFileList(fileList),
    });
  }
  transformFile = (file) => {
    const { OSSData } = this.state;
    const urlObj=new URL(OSSData.putSignUrl)
    file.url = `${urlObj.origin}${urlObj.pathname}`;
    file.fileUrl = `${urlObj.origin}${urlObj.pathname}`;
    file.uid = OSSData.fileId;
    file.newUploadFlag = true;
    return file;
  };
  // getExtraData = (file) => {
  //   const { OSSData } = this.state;
  //   return {
  //     key: `${OSSData.dir}/${OSSData.fileId}`,
  //     dir: OSSData.dir,
  //     OSSAccessKeyId: OSSData.accessid,
  //     policy: OSSData.policy,
  //     Signature: OSSData.signature,
  //   };
  // };
  onChange = ({ fileList, file, event }) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange([...fileList]);
    }
  };

  beforeUpload = (file): any => {
    let {
      maxFileLength = 4096,
      minFileLength = 0,
      fileType = "image,doc,excel,ppt,pdf,video",
      filePatten = "(.jpg|.png|.svg|.gif|.ps|.jpeg|.bmp)$",
    } = this.props;
    if (!new RegExp(filePatten).test(file.name)) {
      message.warn(`文件类型无效！`);
      return false;
    }
    const suffix = file.name.slice(file.name.lastIndexOf("."));
    const isLtMaxFileLength = file.size / 1024 / 1024 < maxFileLength;
    if (!isLtMaxFileLength) {
      message.warn(`单个文件体积不能大于${maxFileLength}MB`);
      return isLtMaxFileLength;
    }
    const isGtMaxFileLength = file.size / 1024 / 1024 > minFileLength;
    if (!isGtMaxFileLength) {
      message.warn(`单个文件体积不能小于${minFileLength}MB`);
      return isGtMaxFileLength;
    }

    return new Promise<void>(async (resolve, reject) => {
      try {
        let data = await this.uploadService.getOssData(
          this.props.uploadSignURL
        );
        await this.setState({
          OSSData: data,
        });
        resolve();
      } catch (error) {
        reject();
      }
    });
  };

  getExtendInfoData = async (fileList) => {
    for await (const item of fileList) {
      if (!item.extendInfo) {
        let imgExtendInfo = await this.uploadService.getExtendInfoData(
          `${item.fileUrl}?x-oss-process=image/info`
        );
        item.extendInfo = imgExtendInfo;
      } else if (typeof item.extendInfo === "string") {
        try {
          item.extendInfo = JSON.parse(item.extendInfo);
        } catch (error) {}
      }
    }
  };
  handlePreview = async (file) => {
    await this.getExtendInfoData(this.state.fileList);
    let images = this.state.fileList.map((item) => {
      let w = item.extendInfo.ImageWidth.value;
      let h = item.extendInfo.ImageHeight.value;
      let { Orientation = { value: 1 } } = item.extendInfo;
      if (Orientation.value == 6 || Orientation.value == 8) {
        [w, h] = [h, w];
      }
      return {
        src: `${item.fileUrl}?x-oss-process=style/fullview`,
        w: w,
        h: h,
      };
    });
    const pswpElement = document.querySelectorAll(".pswp")[0];
    const options = {
      history: false,
      mainClass: "pswp--minimal--dark",
      getThumbBoundsFn: (index) => {
        let thumbnail = this.ref.current.querySelectorAll(
          ".ant-upload-list-item-image"
        )[index];
        let pageYScroll =
          window.pageYOffset || document.documentElement.scrollTop;
        let rect = thumbnail.getBoundingClientRect();
        return {
          x: rect.left,
          y: rect.top + pageYScroll,
          w: rect.width,
        };
      },
      barsSize: {
        top: 0,
        bottom: 0,
      },
      index: this.state.fileList.findIndex((item) => item.uid === file.uid), // start at first slide
      shareEl: false,
    };
    // Initializes and opens PhotoSwipe
    const gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default,
      images,
      options
    );
    gallery.init();
  };
  handleCancel = () => this.setState({ previewVisible: false });
  customRequest=(options: RcCustomRequestOptions)=>{
    const {file,onProgress,onSuccess}=options
    const xhr = new XMLHttpRequest()
    xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
            onProgress({ percent:event.loaded/event.total*100 },file)
        }
    })
    xhr.addEventListener('load', (event) => {
        // 文件上传完成
        console.log('文件上传完成', event)
        if (xhr.status === 200) {
          onSuccess(xhr.response,file )    
        }
    })
    xhr.addEventListener('error', (event) => {
        // 文件上传发生错误
        console.error('文件上传发生错误',event)
    })
    xhr.open('PUT', this.state.OSSData.putSignUrl)
    xhr.setRequestHeader('Content-Type', file.type);
    xhr.send(file)
  }
  render() {
    const uploadButton = (
      <div>
        <Icon style={{ fontSize: 40 }} type="cloud-upload" />
        <div className="ant-upload-text">上传图片</div>
        {/* <div className="subTitle">支持JPG、PNG格式</div> */}
      </div>
    );
    const { fileList } = this.state;
    const {
      multiple = false,
      directory = false,
      single = false,
      preview = true,
      upload = true,
      maxFileNumber = single ? 1 : 100,
    } = this.props;
    return (
      <span className="upload-wrap" ref={this.ref}>
        <Upload
          name="file"
          multiple={multiple}
          className="avatar-uploader"
          listType="picture-card"
          directory={directory}
          fileList={fileList}
          showUploadList={{
            showPreviewIcon: preview,
            showRemoveIcon: upload,
            showDownloadIcon: true,
          }}
          onPreview={this.handlePreview}
          action={this.state.OSSData.host}
          onChange={this.onChange}
          transformFile={this.transformFile}
          // data={this.getExtraData}
          customRequest={this.customRequest}
          beforeUpload={this.beforeUpload}
        >
          {upload
            ? fileList.length >= maxFileNumber
              ? null
              : uploadButton
            : null}
        </Upload>
        <GalleryTemplate />
      </span>
    );
  }
}
